/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useMemo, useCallback, useContext } from "react";

import styled from "styled-components";

import renewSession from "./renew-session";
import TimeoutContext from "./timeout-context";
import useGlobalRenewEvent from "./use-global-renew-event";
import ConfigurationContext from "../../app/configuration-context";
import Modal from "../../generic/headerless-modal/headerless-modal";
import useCountdown from "../../generic/hooks/use-countdown/use-countdown";
import getQueryStringVariable from "../../utils/get-query-string-variable";
import InactiveAlert from "../inactive-alert/inactive-alert";

const HiddenCounter = styled.span`
display:none;
`;

const defaultObj = {};
const TimeoutCounter = ({
  inactivityMinutes = 58,
  renewSessionFunc: propRenewSessionFunc = renewSession,
  routingService,
  children
}) => {
  const configuration = useContext(ConfigurationContext) || defaultObj;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const renewSessionFunc = useCallback(propRenewSessionFunc, []);

  const seconds = useMemo(() => {
    const {isAutomation = false} = configuration;
    const fallback = inactivityMinutes * 60000;
    let timeoutMili = fallback;
    if (isAutomation) {
      try {
        timeoutMili = parseInt(getQueryStringVariable("timeout_milliseconds"));
      } catch (e) {
        timeoutMili = -1;
      }

    }
    //don't let us be less than 10 seconds on our timeout counter
    if (isNaN(timeoutMili) || timeoutMili < 10000) {
      timeoutMili = fallback;
    }
    return timeoutMili / 1000;


  },[inactivityMinutes, configuration]);

  const [modalActive, setModalActive] = useState(false);

  const onCountDownComplete = useCallback(() => {
    setModalActive(true);
  },[])
  const {remaining, restart,stop} = useCountdown({seconds,onComplete:onCountDownComplete,autoStart:true});

  useGlobalRenewEvent({onRenew:restart})

  const onClick = useCallback(async () => {
    //remaining is a number of seconds remaining
    const threshold = 240;//if the user has a click event that registers up to this level within 4 minutes
    //of our timeout, we want to renew and extend.
    if (remaining <= threshold) {
      if (typeof renewSessionFunc === "function") {
        await renewSessionFunc();
        //note: a storybook implementation would need to dispatch a renew event
        //the app implementation makes a fetch wrapper call, which dispatches renew when it succeeds.
      } else {
        //this really should never hit, but just a precaution.
        restart();
      }
    }
  },[remaining, renewSessionFunc, restart])


  const modalContinue = useCallback(async () => {
    renewSessionFunc();
    restart();
    setModalActive(false);
  },[renewSessionFunc, restart]);

  const modalExpire = useCallback(() => {
    stop();
    setModalActive(false);
    routingService.logOut();
  },[routingService,stop]);

  const memoObjectValue = useMemo(() => {
    return  {renew: renewSessionFunc};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div onClick={onClick}>
      {modalActive ? (
        <Modal onCloseGesture={modalContinue} active={modalActive} hideClose={true}>
          <InactiveAlert
            seconds={60}
            onDismiss={modalContinue}
            onExpire={modalExpire}
          />
        </Modal>
      ) : null}
      <HiddenCounter data-id="counter">{remaining}</HiddenCounter>
      <TimeoutContext.Provider value={memoObjectValue}>
        {children}
      </TimeoutContext.Provider>
    </div>
  );
};

export default TimeoutCounter;
